<template lang="pug">
  #prematch.page
    .level.is-mobile
      .level-left
        a.level-item
          span.tag.is-pulled-right.is-info.is-unselectable Processing: {{ matches.length }}
    .columns.is-mobile.is-multiline
      .column.is-full-mobile
        .title.is-5 Processing
      .column
        .columns.is-mobile.is-centered.filters
          .column.is-narrow
            .tags.has-addons
              .tag.is-medium(:class="{'is-dark': sort.total !== null}" @click="sort='total'")
                span.has-text-light(v-html="sort.total === true ? '↑' : '↓'" :class="{'has-text-success': sort.total === true, 'has-text-danger': sort.total === false}")
                span TO
              .tag.is-medium(:class="{'is-dark': sort.handicap !== null}" @click="sort='handicap'")
                span.has-text-light(v-html="sort.handicap === true ? '↑' : '↓'" :class="{'has-text-success': sort.handicap === true, 'has-text-danger': sort.handicap === false}")
                span AH
          .column.is-narrow
            button.button(:class="{'is-success': changesOnly }" @click="changesOnlyToggle")
              span.icon.is-small
                i.fas.fa-exchange-alt
          .column.is-narrow
            .select
              select(v-model="companyId")
                option(v-for="item of companies" :value="item._id") {{ item.name }}
    template(v-if="matches.length")
      PrematchMatch(v-for="match in matches" :match="match" :source="source" :key="`${match._id}`")
    .notification(v-else)
      .content
        p No matches
</template>

<script>
import PrematchMatch from "@/components/PrematchMatch";

export default {
  name: "prematch",
  components: {
    PrematchMatch
  },
  data() {
    return {
      maxHistory: 3
    };
  },
  computed: {
    sort: {
      get() {
        return this.$store.state.prematch.sort;
      },
      set(v) {
        this.$store.commit("prematchSort", v);
      }
    },
    changesOnly() {
      return this.$store.state.prematch.filters.changesOnly;
    },
    companyId: {
      get() {
        return this.$store.state.prematch.filters.companyId;
      },
      set(v) {
        this.$store.commit("prematchCompanyId", v);
      }
    },
    companies() {
      const companies = this.$store.getters.prematchCompanies;
      return [{ _id: 0, name: "All" }, ...companies];
    },
    source() {
      return this.$store.getters.getPrematchSource;
    },
    matches() {
      return this.$store.getters.prematchMatches;
    }
  },
  methods: {
    changesOnlyToggle() {
      this.$store.commit("prematchChangesOnly", !this.changesOnly);
    }
  }
};
</script>

<style lang="scss" scoped>
#prematch {
  .source-link {
    top: -5rem;
    padding: 1rem;
    color: $defaultColor;
    text-transform: uppercase;
    font-weight: bold;
    background: transparent;
    transition: all 0.2s linear;

    span:not(.icon) {
      font-size: 1.3rem;
    }

    .wrapper {
      border-bottom: 2px solid $brandColor;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.3);
      color: lighten($brandColor, 20%);
    }
  }

  .tags {
    .tag {
      cursor: pointer;
      user-select: none;
    }
  }

  .filters {
    @media screen and (min-width: $tablet) {
      justify-content: flex-end;
    }

    .tag.is-medium {
      font-size: 1.1rem;
    }
  }
}
</style>
